export const COLUMN_KEYS = {
  ACTION: "action",
  NO: "no",
};

export const COLUMN_LABELS = {
  [COLUMN_KEYS.ACTION]: "Action",
  [COLUMN_KEYS.NO]: "No",
};

export const FILTER_KEYS = {
  PAGE: "page",
  PAGE_SIZE: "page_size",
  PRODUCTS: "products",
  SEARCH: "search",
  SORTERS: "sorters",
};

export const FILTER_LABELS = {
  [FILTER_KEYS.SEARCH]: "Search",
  [FILTER_KEYS.SORTERS]: "Sorters",
};

export const SORTER_KEYS = {
  SORT_BY: "sort_by",
  SORT_ORDER: "sort_order",
};
